import { CopyButton } from "Components/CopyButton";
import styles from "./index.module.css";
import { CSSProperties, ReactNode } from "react";

type Props = {
  label: string;
  contentFirst: {
    label?: string;
    content: ReactNode;
    isContentID?: boolean;
    sliceLength?: number;
  }[];
  style?: CSSProperties;
};

export const AllInfoComponent = ({ contentFirst, label, style }: Props) => {
  return (
    <div className={styles.info} style={style}>
      <div style={{ color: "#000000", fontWeight: 700 }}>{label}</div>
      {contentFirst.map((v, i) => {
        const isOne = !!v.label;

        if (!isOne) {
          return <div key={i}>{v.content}</div>;
        } else {
          return (
            <div key={i} style={{ display: "flex" }}>
              <span style={{ marginRight: 10, color: "#868686" }}>{v.label}</span>
              {v.isContentID ? (
                <CopyButton
                  copyText="copied"
                  text={v.content as string}
                  wait={1000}
                  className={styles.copyBtn}
                  sliceOfText={v.sliceLength}
                />
              ) : (
                <div style={{ color: "#000000" }}>{v.content}</div>
              )}
            </div>
          );
        }
      })}
    </div>
  );
};
